export default __webpack_public_path__ + "static/media/pcatr@2x.9babe591.png";